// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1By3H","label":"Labeled_label__218p8","divider":"Labeled_divider__CgVGc"};